import React from "react";
import { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  Flex,
  SimpleGrid,
  Text,
  Textarea,
  RadioGroup,
  Stack,
  useColorModeValue,
  useColorMode,
  Skeleton,
  SkeletonText,
  Spacer,
  Modal,
  ModalContent,
  ModalBody,
  ModalFooter,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Box,
  Divider,
  Tooltip,
} from "@chakra-ui/react";
import apiUrl from "variables/api";

import { toast } from "react-toastify";

import ReactSelect from "react-select";
import Creatable from "react-select/creatable";

import locations from "variables/locations";
import { format, toZonedTime } from "date-fns-tz";

import {
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Button,
} from "@chakra-ui/react";

import {
  onSiteVehiclesOptionsJRG1,
  onSiteVehiclesOptionsJRG2,
  onSiteVehiclesOptionsSP,
  onSiteVehiclesOptionsWSP,
  sluzby,
  grupy,
} from "variables/general";

import Card from "components/Card/Card.js";
import CustomCheckbox from "components/Checkbox/CustomCheckbox";
import CustomCheckboxButton from "components/Checkbox/CustomCheckboxButton";
import darkStyles from "variables/darkStyles";
import axios from "axios";
import { FaRotate } from "react-icons/fa6";

const refreshDateTime = () => {
  const now = new Date();
  const timeZone = "Europe/Warsaw";
  const polandTime = toZonedTime(now, timeZone);
  return format(polandTime, "yyyy-MM-dd'T'HH:mm");
};

const initialValues = {
  dateTime: refreshDateTime(),
  reporter: "",
  location: "",
  commander: "",
  incidentType: "",
  onSiteServices: [],
  onSiteVehicles: [],
  incidentDescription: "",
};

const initialWSPValues = {
  location: "",
  incidentType: "",
  onSiteVehicles: [],
  incidentDescription: "",
};

const initialNWValues = {
  incidentGroup: "",
  incidentDescription: "",
};

export default function Sk() {
  const { colorMode } = useColorMode();

  const [formData, setFormData] = useState({
    dateTime: "",
    reporter: "",
    location: "",
    commander: "",
    incidentType: "",
    onSiteServices: [],
    onSiteVehicles: [],
    incidentDescription: "",
  });

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: DyspIsOpen,
    onOpen: DyspOnOpen,
    onClose: DyspOnClose,
  } = useDisclosure();
  const {
    isOpen: GroupIsOpen,
    onOpen: GroupOnOpen,
    onClose: GroupOnClose,
  } = useDisclosure();
  const cancelRef = React.useRef();
  const formikRef = React.useRef();
  const formikWSPRef = React.useRef();
  const formikNWRef = React.useRef();

  const [WSPisOpen, setWSPOpen] = useState(false);

  const [NWisOpen, setNWOpen] = useState(false);

  const WSPonOpen = () => setWSPOpen(true);
  const WSPonClose = () => setWSPOpen(false);

  const NWonOpen = () => setNWOpen(true);
  const NWonClose = () => setNWOpen(false);

  const [groupList, setGroupList] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/groups-list", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        setGroupList(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [vehicles, setVehicles] = useState([]);
  const [disabledVehicles, setDisabledVehicles] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/vehicles", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        const vehicles = response.data;
        const formattedData = vehicles.reduce((acc, item) => {
          const existingUnit = acc.find((unit) => unit.unit === item.unit);
          if (existingUnit) {
            existingUnit.vehicles.push(item.operationalNumber);
          } else {
            acc.push({ unit: item.unit, vehicles: [item.operationalNumber] });
          }
          return acc;
        }, []);
        setVehicles(formattedData);

        const disabledVehicles = vehicles
          .filter((vehicle) => vehicle.disabled)
          .map((vehicle) => vehicle.operationalNumber);
        setDisabledVehicles(disabledVehicles);

        console.log(formattedData);
        console.log(disabledVehicles);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    console.log("Dane formularza", values);

    setFormData(values);
    onOpen();
  };

  const validate = (values) => {
    const errors = {};

    if (!values.onSiteVehicles || values.onSiteVehicles.length === 0) {
      errors.onSiteVehicles = "Musisz wybrać co najmniej jedno pole";
    }

    if (!values.commander || values.commander.length === 0) {
      errors.commander = "Musisz wybrać dowódce";
    }

    if (!values.incidentType) {
      errors.incidentType = "Musisz wybrać rodzaj zdarzenia";
    }

    if (!values.dateTime) {
      errors.dateTime = "Musisz wybrać godzinę";
    }

    if (!values.reporter) {
      errors.reporter = "Musisz podać zgłaszającego";
    }

    if (!values.location) {
      errors.location = "Musisz podać lokalizację";
    }

    if (values.incidentDescription.length < 10) {
      errors.incidentDescription =
        "Opis zdarzenia musi zawierać co najmniej 10 znaków";
    }

    return errors;
  };

  const validateWSP = (values) => {
    const errors = {};

    if (!values.onSiteVehicles || values.onSiteVehicles.length === 0) {
      errors.onSiteVehicles = "Musisz wybrać co najmniej jedno pole";
    }

    if (!values.incidentType) {
      errors.incidentType = "Musisz wybrać rodzaj zdarzenia";
    }

    if (!values.location) {
      errors.location = "Musisz podać lokalizację";
    }

    console.log(errors);
    return errors;
  };

  const validateNW = (values) => {
    const errors = {};

    if (!values.incidentDescription) {
      errors.incidentDescription = "Musisz podać opis wezwania";
    }

    if (!values.incidentGroup) {
      errors.incidentGroup = "Musisz wybrać odpowiednią grupę";
    }

    console.log(errors);
    return errors;
  };

  const handleFinalSubmit = (values) => {
    console.log("Wysyłanie formularza", formData);
    if (!formikRef.current.isSubmitting) return;
    onClose();
    axios
      .post(apiUrl + "/data/sk", formData, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        if (response.data.success) {
          formikRef.current.resetForm();
          formikRef.current.values.dateTime = refreshDateTime();
          formikRef.current.setSubmitting(false);
          navigator.clipboard
            .writeText(
              `frakcja Raport SK: ${response.data.raportID} | Dowódca: ${formData.commander.label}`
            )
            .then(() => {
              console.log("ID copied to clipboard");
            })
            .catch((err) => {
              console.error("Could not copy text: ", err);
            });
          return toast.success(
            "Pomyślnie wysłano raport SK | ID: " + response.data.raportID
          );
        } else {
          formikRef.current.setSubmitting(false);
          return toast.error("Napotkano błąd podczas wysyłania raportu SK");
        }
      })
      .catch((error) => {
        console.error(error);
        formikRef.current.setSubmitting(false);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  };

  const handleFinalCloseSubmit = (values) => {
    formikRef.current.setSubmitting(false);
    onClose();
    //setSubmitting(false)
  };

  const handleWSPSubmit = (values, { setSubmitting, resetForm }) => {
    console.log("Wysyłanie formularza wzywania WSP", formData);
    axios
      .post(apiUrl + "/data/wsp", values, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        if (response.data.success) {
          formikWSPRef.current.resetForm();
          formikWSPRef.current.setSubmitting(false);
          WSPonClose();
          toast.success("Pomyślnie wysłano wezwanie WSP");
        } else {
          formikNWRef.current.setSubmitting(false);
          return toast.error("Napotkano błąd podczas wysyłania wezwania WSP");
        }
      })
      .catch((error) => {
        console.error(error);
        formikWSPRef.current.setSubmitting(false);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  };

  const WSPDeleteLast = () => {
    axios
      .delete(apiUrl + "/data/wsp", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        if (response.data.success) {
          WSPonClose();
          toast.success("Pomyślnie usunięto ostatnie wezwanie WSP");
        } else if (response.data.success === false) {
          return toast.error(
            "Nie można usunąć ostatniego wezwania WSP, ponieważ nie jesteś jego autorem"
          );
        } else {
          return toast.error("Napotkano błąd podczas usuwania wezwania WSP");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  };

  const handleNWSubmit = (values, { setSubmitting, resetForm }) => {
    console.log("Wysyłanie formularza nagłych wezwań", values);
    axios
      .post(apiUrl + "/data/nw", values, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        if (response.data.success) {
          formikNWRef.current.resetForm();
          formikNWRef.current.setSubmitting(false);
          NWonClose();
          toast.success("Pomyślnie wysłano informacje o nagłym wezwaniu");
        } else {
          formikNWRef.current.setSubmitting(false);
          return toast.error("Napotkano błąd podczas wysyłania raportu SK");
        }
      })
      .catch((error) => {
        console.error(error);
        formikNWRef.current.setSubmitting(false);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  };

  const [peoples, setPeoples] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/peoples", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        response.data.push({ value: "WSP", label: "WSP" });
        setPeoples(
          response.data.filter(
            (person) => person.value !== localStorage.getItem("id")
          )
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [WSPReady, setWSPReady] = useState(undefined);
  useEffect(() => {
    const fetchWSPStatus = () => {
      axios
        .get(apiUrl + "/data/wsp", {
          headers: { "x-access-token": localStorage.getItem("token") },
        })
        .then((response) => {
          setWSPReady(response.data.status);
          console.log(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    };

    fetchWSPStatus();
    const intervalId = setInterval(fetchWSPStatus, 60000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <Text as="p" fontWeight="bold">
          Gotowość WSP:{" "}
          <Text as="span" color={WSPReady === 1 ? "green.400" : "red.400"}>
            {WSPReady === 1
              ? "GOTOWI"
              : WSPReady === 0
              ? "NIE GOTOWI"
              : WSPReady === undefined
              ? "Wczytywanie"
              : "BŁĄD"}
          </Text>
        </Text>
        <Flex direction="column">
          <Formik
            initialValues={initialValues}
            validate={validate}
            // validateOnChange={false}
            // validateOnBlur={false}
            onSubmit={handleSubmit}
            innerRef={formikRef}
          >
            {({ isSubmitting, formik }) => (
              <Form>
                <SimpleGrid
                  columns={{ sm: 1, md: 2, xl: 4 }}
                  spacing="24px"
                  mb="20px"
                >
                  <Field name="dateTime">
                    {({ field, form }) => (
                      <FormControl
                        id="dateTime"
                        isRequired
                        isInvalid={
                          form.errors.dateTime && form.touched.dateTime
                        }
                      >
                        <FormLabel display="flex" alignItems="center" gap="8px">
                          Data i godzina
                          <Box
                            onClick={(e) => {
                              form.setFieldValue("dateTime", refreshDateTime());
                              console.log("Odświeżono datę i godzinę", form.values.dateTime);
                              toast.success("Odświeżono datę i godzinę");
                            }}
                            cursor="pointer"
                          >
                            <FaRotate color="lightblue" />
                          </Box>
                        </FormLabel>
                        <Input
                          type="datetime-local"
                          {...field}
                          placeholder="Data i godzina"
                        />
                        <FormErrorMessage>
                          {form.errors.dateTime}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>

                  <Field name="reporter">
                    {({ field, form }) => (
                      <FormControl
                        id="reporter"
                        isRequired
                        isInvalid={
                          form.errors.reporter && form.touched.reporter
                        }
                      >
                        <FormLabel>Zgłaszający</FormLabel>
                        <Input {...field} placeholder="Zgłaszający" />
                        <FormErrorMessage>
                          {form.errors.reporter}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>

                  <Field name="location">
                    {({ field, form }) => (
                      <FormControl
                        id="location"
                        isRequired
                        isInvalid={
                          form.errors.location && form.touched.location
                        }
                      >
                        <FormLabel>Lokalizacja</FormLabel>
                        <Creatable
                          {...field}
                          options={locations}
                          placeholder="Wybierz..."
                          styles={darkStyles()}
                          value={form.values[field.name]}
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                          formatCreateLabel={(inputValue) =>
                            `Niestandardowa: ${inputValue}`
                          }
                        />
                        <FormErrorMessage>
                          {form.errors.location}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>

                  <Field name="commander">
                    {({ field, form }) => (
                      <FormControl
                        id="commander"
                        isRequired
                        isInvalid={
                          form.errors.commander && form.touched.commander
                        }
                      >
                        <FormLabel>Dowódca</FormLabel>
                        <ReactSelect
                          {...field}
                          noOptionsMessage={() => "Brak dostępnych opcji"}
                          options={peoples}
                          placeholder="Wybierz..."
                          isLoading={peoples.length === 0}
                          styles={darkStyles()}
                          value={form.values.commander}
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                        />
                        <FormErrorMessage>
                          {form.errors.commander}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                </SimpleGrid>
                <SimpleGrid
                  columns={{ sm: 1, md: 2, xl: 2 }}
                  spacing="24px"
                  mb="20px"
                >
                  <Field name="incidentType">
                    {({ field, form }) => (
                      <FormControl
                        id="incidentType"
                        isRequired
                        isInvalid={
                          form.errors.incidentType && form.touched.incidentType
                        }
                      >
                        <FormLabel fontWeight={"bold"}>
                          Rodzaj zdarzenia
                        </FormLabel>
                        <RadioGroup name="incidentType" colorScheme="red">
                          <Stack direction="row">
                            <CustomCheckbox
                              key="P"
                              label="Pożar"
                              isChecked={form.values.incidentType == "P"}
                              onChange={() => {
                                form.setFieldValue(field.name, "P");
                              }}
                            />
                            <CustomCheckbox
                              key="MZ"
                              label="Miejscowe zagrożenie"
                              isChecked={form.values.incidentType == "MZ"}
                              onChange={() => {
                                form.setFieldValue(field.name, "MZ");
                              }}
                            />
                          </Stack>
                        </RadioGroup>
                        <FormErrorMessage>
                          {form.errors.incidentType}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>

                  <Field name="onSiteServices">
                    {({ field, form }) => (
                      <FormControl
                        isInvalid={
                          form.errors.onSiteServices &&
                          form.touched.onSiteServices
                        }
                      >
                        <FormLabel fontWeight={"bold"}>
                          Służby na miejscu
                        </FormLabel>
                        <Stack direction="row">
                          {sluzby.map((option) => (
                            <CustomCheckbox
                              key={option.value}
                              label={option.label}
                              colorScheme={option.color}
                              isChecked={form.values.onSiteServices.includes(
                                option.value
                              )}
                              onChange={() => {
                                const nextValue = field.value.includes(
                                  option.value
                                )
                                  ? field.value.filter(
                                      (value) => value !== option.value
                                    )
                                  : [...field.value, option.value];
                                form.setFieldValue(field.name, nextValue);
                              }}
                            />
                          ))}
                        </Stack>
                        <FormErrorMessage>
                          {form.errors.onSiteServices}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                </SimpleGrid>
                <Field name="onSiteVehicles">
                  {({ field, form }) => (
                    <FormControl
                      id="onSiteVehicles"
                      isInvalid={
                        form.errors.onSiteVehicles &&
                        form.touched.onSiteVehicles
                      }
                    >
                      <FormLabel textAlign={"center"}>
                        <Text fontWeight={"bold"} fontSize={"md"}>
                          Wysłane zastępy
                        </Text>
                      </FormLabel>
                      <Flex
                        direction={{ base: "column", xl: "row" }}
                        wrap="wrap"
                        justifyContent={{ base: "center", xl: "space-between" }}
                        alignItems="stretch"
                      >
                        {vehicles.length === 0 ? (
                          <Skeleton height="200px" width="100%" />
                        ) : (
                          vehicles.map((unit, index) => (
                            <React.Fragment key={unit.unit}>
                              <Flex direction={"column"} flex="1" mx={2} mb={4}>
                                <FormLabel
                                  fontWeight="bold"
                                  textAlign={"center"}
                                >
                                  {unit.unit}
                                </FormLabel>
                                <SimpleGrid
                                  columns={{ sm: 2, md: 3, xl: 3 }}
                                  spacing="24px"
                                  mb="20px"
                                >
                                  {unit.vehicles.map((vehicle) => (
                                    <CustomCheckboxButton
                                      key={vehicle}
                                      label={vehicle}
                                      disabled={disabledVehicles.includes(
                                        vehicle
                                      )}
                                      isChecked={form.values.onSiteVehicles.includes(
                                        vehicle
                                      )}
                                      onChange={() => {
                                        const nextValue = field.value.includes(
                                          vehicle
                                        )
                                          ? field.value.filter(
                                              (value) => value !== vehicle
                                            )
                                          : [...field.value, vehicle];
                                        form.setFieldValue(
                                          field.name,
                                          nextValue
                                        );
                                      }}
                                    />
                                  ))}
                                </SimpleGrid>
                              </Flex>
                              {index < vehicles.length - 1 && (
                                <Divider
                                  orientation="vertical"
                                  height="auto"
                                  mx={2}
                                />
                              )}
                            </React.Fragment>
                          ))
                        )}
                      </Flex>
                      <FormErrorMessage>
                        {form.errors[field.name]}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Field name="incidentDescription">
                  {({ field, form }) => (
                    <FormControl
                      id="incidentDescription"
                      isInvalid={
                        form.errors[field.name] && form.touched[field.name]
                      }
                      isRequired
                    >
                      <FormLabel>Opis zdarzenia</FormLabel>
                      <Textarea
                        {...field}
                        placeholder="Opis zdarzenia"
                        maxH={"500px"}
                        maxLength={"4096"}
                      />
                      <FormErrorMessage>
                        {form.errors[field.name]}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Button
                  mt={4}
                  colorScheme="red"
                  isLoading={isSubmitting}
                  type="submit"
                >
                  Wyślij
                </Button>
                <Button mt={4} ml={2} colorScheme="gray" onClick={WSPonOpen}>
                  Wzywanie WSP
                </Button>
                <Button mt={4} ml={2} colorScheme="green" onClick={NWonOpen}>
                  Nagłe wezwania
                </Button>
                <Button mt={4} ml={2} colorScheme="yellow" onClick={DyspOnOpen}>
                  Panel dyspozytora
                </Button>
                <Button
                  mt={4}
                  ml={2}
                  colorScheme="orange"
                  onClick={GroupOnOpen}
                >
                  Lista grup
                </Button>

                <Modal isOpen={GroupIsOpen} onClose={GroupOnClose} size="2xl">
                  <ModalContent>
                    <ModalBody>
                      <SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} gap={5}>
                        <Box>
                          <Text fontSize="xl" fontWeight="bold" mb={2}>
                            SGRT
                          </Text>
                          {groupList?.sgrt?.map((group) => (
                            <Text>{group}</Text>
                          ))}
                        </Box>
                        <Box>
                          <Text fontSize="xl" fontWeight="bold" mb={2}>
                            SGRChem
                          </Text>
                          {groupList?.sgrchem?.map((group) => (
                            <Text>{group}</Text>
                          ))}
                        </Box>
                        <Box>
                          <Text fontSize="xl" fontWeight="bold" mb={2}>
                            SGRMed
                          </Text>
                          {groupList?.sgrmed?.map((group) => (
                            <Text>{group}</Text>
                          ))}
                        </Box>
                        <Box>
                          <Text fontSize="xl" fontWeight="bold" mb={2}>
                            SGPR
                          </Text>
                          {groupList?.sgpr?.map((group) => (
                            <Text>{group}</Text>
                          ))}
                        </Box>
                      </SimpleGrid>
                    </ModalBody>
                    <ModalFooter gap={3}>
                      <Button colorScheme="red" onClick={GroupOnClose}>
                        Zamknij
                      </Button>
                    </ModalFooter>
                  </ModalContent>
                </Modal>

                <Modal isOpen={DyspIsOpen} onClose={DyspOnClose} size="7xl">
                  <ModalContent>
                    <ModalBody>
                      <iframe
                        src="https://docs.google.com/spreadsheets/d/1YVl1ZjllNa2kYN_wKBrwUl1vnBThP-hIzcfmI3xdSpo/edit?usp=sharing"
                        width="100%"
                        height="900px"
                        frameBorder="0"
                        allowFullScreen
                      ></iframe>
                    </ModalBody>
                    <ModalFooter gap={3}>
                      <Button
                        colorScheme="gray"
                        as={"a"}
                        target="_blank"
                        href="https://docs.google.com/spreadsheets/d/1YVl1ZjllNa2kYN_wKBrwUl1vnBThP-hIzcfmI3xdSpo/edit?usp=sharing"
                      >
                        Otworz w nowej karcie
                      </Button>
                      <Button colorScheme="red" onClick={DyspOnClose}>
                        Zamknij
                      </Button>
                    </ModalFooter>
                  </ModalContent>
                </Modal>

                <AlertDialog
                  isOpen={isOpen}
                  leastDestructiveRef={cancelRef}
                  onClose={onClose}
                >
                  <AlertDialogOverlay>
                    <AlertDialogContent>
                      <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        Potwierdź zgłoszenie
                      </AlertDialogHeader>

                      <AlertDialogBody mt={-3}>
                        Czy na pewno chcesz wysłać te dane? <br />
                        Data i godzina: {formData.dateTime.replace(
                          "T",
                          " "
                        )}{" "}
                        <br />
                        Zgłaszający: {formData.reporter} <br />
                        Lokalizacja: {formData.location.label} <br />
                        Dowódca: {formData.commander.label} <br />
                        Rodzaj zdarzenia:{" "}
                        {formData.incidentType
                          .replace("P", "Pożar")
                          .replace("MZ", "Miejscowe zagrożenie")
                          .replace("AF", "Alarm fałszywy")}{" "}
                        <br />
                        Służby na miejscu: {formData.onSiteServices.join(
                          ", "
                        )}{" "}
                        <br />
                        Wysłane zastępy: {formData.onSiteVehicles.join(
                          ", "
                        )}{" "}
                        <br />
                        Opis zdarzenia:{" "}
                        {formData.incidentDescription !== ""
                          ? formData.incidentDescription
                          : "-"}
                      </AlertDialogBody>

                      <AlertDialogFooter>
                        <Button
                          ref={cancelRef}
                          onClick={handleFinalCloseSubmit}
                        >
                          Anuluj
                        </Button>
                        <Button
                          colorScheme="red"
                          onClick={handleFinalSubmit}
                          ml={3}
                        >
                          Wyślij
                        </Button>
                      </AlertDialogFooter>
                    </AlertDialogContent>
                  </AlertDialogOverlay>
                </AlertDialog>
              </Form>
            )}
          </Formik>
          <AlertDialog isOpen={WSPisOpen} onClose={WSPonClose}>
            <AlertDialogOverlay>
              <AlertDialogContent>
                <AlertDialogHeader fontSize="lg" fontWeight="bold">
                  Wzywanie WSP
                </AlertDialogHeader>

                <AlertDialogBody mt={-3}>
                  <Formik
                    initialValues={initialWSPValues}
                    validate={validateWSP}
                    // validateOnChange={false}
                    // validateOnBlur={false}
                    onSubmit={handleWSPSubmit}
                    innerRef={formikWSPRef}
                  >
                    {({ isSubmitting, formik }) => (
                      <Form>
                        <SimpleGrid
                          columns={{ sm: 1, md: 1, xl: 1 }}
                          spacing="24px"
                          mb="20px"
                        >
                          <Field name="location">
                            {({ field, form }) => (
                              <FormControl
                                id="location"
                                isRequired
                                isInvalid={
                                  form.errors.location && form.touched.location
                                }
                              >
                                <FormLabel>Lokalizacja</FormLabel>
                                <Creatable
                                  {...field}
                                  options={locations}
                                  placeholder="Wybierz..."
                                  styles={darkStyles()}
                                  value={form.values[field.name]}
                                  onChange={(selectedOptions) => {
                                    form.setFieldValue(
                                      field.name,
                                      selectedOptions
                                    );
                                  }}
                                  formatCreateLabel={(inputValue) =>
                                    `Niestandardowa: ${inputValue}`
                                  }
                                />
                                <FormErrorMessage>
                                  {form.errors.location}
                                </FormErrorMessage>
                              </FormControl>
                            )}
                          </Field>
                        </SimpleGrid>
                        <SimpleGrid
                          columns={{ sm: 1, md: 1, xl: 1 }}
                          spacing="24px"
                          mb="20px"
                        >
                          <Field name="incidentType">
                            {({ field, form }) => (
                              <FormControl
                                id="incidentType"
                                isRequired
                                isInvalid={
                                  form.errors.incidentType &&
                                  form.touched.incidentType
                                }
                              >
                                <FormLabel>Rodzaj zdarzenia</FormLabel>
                                <RadioGroup
                                  name="incidentType"
                                  colorScheme="red"
                                >
                                  <Stack direction="row">
                                    <CustomCheckbox
                                      key="P"
                                      label="Pożar"
                                      isChecked={
                                        form.values.incidentType == "P"
                                      }
                                      onChange={() => {
                                        form.setFieldValue(field.name, "P");
                                      }}
                                    />
                                    <CustomCheckbox
                                      key="MZ"
                                      label="Miejscowe zagrożenie"
                                      isChecked={
                                        form.values.incidentType == "MZ"
                                      }
                                      onChange={() => {
                                        form.setFieldValue(field.name, "MZ");
                                      }}
                                    />
                                  </Stack>
                                </RadioGroup>
                                <FormErrorMessage>
                                  {form.errors.incidentType}
                                </FormErrorMessage>
                              </FormControl>
                            )}
                          </Field>
                        </SimpleGrid>
                        <Field name="onSiteVehicles">
                          {({ field, form }) => (
                            <FormControl
                              id="onSiteVehicles"
                              isInvalid={
                                form.errors.onSiteVehicles &&
                                form.touched.onSiteVehicles
                              }
                              isRequired
                            >
                              <FormLabel>Potrzebne zastępy</FormLabel>

                              <SimpleGrid
                                columns={{ sm: 2, md: 3, xl: 3 }}
                                spacing="24px"
                                mb="20px"
                              >
                                {vehicles
                                  .find(
                                    (unit) =>
                                      unit.unit === "Wojskowa Straż Pożarna"
                                  )
                                  ?.vehicles.map((vehicle) => (
                                    <CustomCheckbox
                                      key={vehicle}
                                      label={vehicle}
                                      isChecked={form.values.onSiteVehicles.includes(
                                        vehicle
                                      )}
                                      onChange={() => {
                                        const nextValue = field.value.includes(
                                          vehicle
                                        )
                                          ? field.value.filter(
                                              (value) => value !== vehicle
                                            )
                                          : [...field.value, vehicle];
                                        form.setFieldValue(
                                          field.name,
                                          nextValue
                                        );
                                      }}
                                    />
                                  ))}
                              </SimpleGrid>

                              <FormErrorMessage>
                                {form.errors.onSiteVehicles}
                              </FormErrorMessage>
                            </FormControl>
                          )}
                        </Field>

                        <Field name="incidentDescription">
                          {({ field }) => (
                            <FormControl id="incidentDescription">
                              <FormLabel>Opis zdarzenia</FormLabel>
                              <Textarea
                                {...field}
                                placeholder="Opis zdarzenia"
                                maxH={"500px"}
                              />
                            </FormControl>
                          )}
                        </Field>

                        <Flex gap={2}>
                          <Button
                            mt={4}
                            colorScheme="red"
                            isLoading={isSubmitting}
                            type="submit"
                          >
                            Wyślij
                          </Button>
                          <Button
                            mt={4}
                            colorScheme="gray"
                            type="button"
                            onClick={WSPonClose}
                          >
                            Anuluj
                          </Button>
                          <Button
                            mt={4}
                            colorScheme="gray"
                            onClick={WSPDeleteLast}
                          >
                            Usuń ostatnie wezwanie
                          </Button>
                        </Flex>
                      </Form>
                    )}
                  </Formik>
                </AlertDialogBody>

                <AlertDialogFooter></AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialogOverlay>
          </AlertDialog>

          <AlertDialog isOpen={NWisOpen} onClose={NWonClose}>
            <AlertDialogOverlay>
              <AlertDialogContent>
                <AlertDialogHeader fontSize="lg" fontWeight="bold">
                  Nagłe wezwania
                </AlertDialogHeader>

                <AlertDialogBody mt={-3}>
                  <Formik
                    initialValues={initialNWValues}
                    validate={validateNW}
                    // validateOnChange={false}
                    // validateOnBlur={false}
                    onSubmit={handleNWSubmit}
                    innerRef={formikNWRef}
                  >
                    {({ isSubmitting, formik }) => (
                      <Form>
                        <SimpleGrid
                          columns={{ sm: 1, md: 1, xl: 1 }}
                          spacing="24px"
                          mb="20px"
                        >
                          <Field name="incidentGroup">
                            {({ field, form }) => (
                              <FormControl
                                id="incidentGroup"
                                isRequired
                                isInvalid={
                                  form.errors.incidentGroup &&
                                  form.touched.incidentGroup
                                }
                              >
                                <FormLabel>Potrzebna grupa</FormLabel>
                                <Stack direction="row">
                                  {grupy.map((option) => (
                                    <CustomCheckbox
                                      key={option.value}
                                      label={option.label}
                                      colorScheme={option.color}
                                      isChecked={form.values.incidentGroup.includes(
                                        option.value
                                      )}
                                      onChange={() => {
                                        const nextValue = field.value.includes(
                                          option.value
                                        )
                                          ? field.value.filter(
                                              (value) => value !== option.value
                                            )
                                          : [...field.value, option.value];
                                        form.setFieldValue(
                                          field.name,
                                          nextValue
                                        );
                                      }}
                                    />
                                  ))}
                                </Stack>
                                <FormErrorMessage>
                                  {form.errors.incidentGroup}
                                </FormErrorMessage>
                              </FormControl>
                            )}
                          </Field>
                        </SimpleGrid>

                        <Field name="incidentDescription">
                          {({ field }) => (
                            <FormControl id="incidentDescription" isRequired>
                              <FormLabel>Opis wezwania</FormLabel>
                              <Textarea
                                {...field}
                                placeholder="Opis wezwania"
                                maxH={"500px"}
                              />
                            </FormControl>
                          )}
                        </Field>

                        <Button
                          mt={4}
                          colorScheme="red"
                          isLoading={isSubmitting}
                          type="submit"
                        >
                          Wezwij
                        </Button>
                        <Button
                          mt={4}
                          ml={2}
                          colorScheme="gray"
                          onClick={NWonClose}
                        >
                          Anuluj
                        </Button>
                      </Form>
                    )}
                  </Formik>
                </AlertDialogBody>

                <AlertDialogFooter></AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialogOverlay>
          </AlertDialog>
        </Flex>
      </Card>
    </Flex>
  );
}
